import React from "react";
import { Navbar } from "../components/organisms/Navbar";
import { HeroSection } from "../components/sections/HeroSection";
import { ServicesSection } from "../components/sections/ServicesSection";
// import { EaseSection } from "../components/sections/EaseSection";
import { PricingSection } from "../components/sections/PricingSection";
// import { PromiseSection } from '../components/sections/PromiseSection';
// import { TestimonialsSection } from '../components/sections/TestimonialsSection';
// import { ClientsSection } from '../components/sections/ClientsSection';
import { FAQSection } from "../components/sections/FAQSection";
import { CTASection } from "../components/sections/CTASection";
import { FooterSection } from "../components/sections/FooterSection";
import { WhatsAppFloatingButton } from "../components/WhatsAppFloatingButton";

export const NewLandingPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      {/* <EaseSection /> */}
      <PricingSection />
      {/* <PromiseSection /> */}
      {/* <TestimonialsSection />
      <ClientsSection /> */}
      <FAQSection />
      <CTASection />
      <FooterSection />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default NewLandingPage;
